import { Phone, WhatsappLogo } from '@phosphor-icons/react';
import { useSettings } from '@/context/SettingsContext';

export default function Contact() {
  const { settings } = useSettings();
  const wa = settings.whatsapp_number || '919971236105';
  const primary = settings.primary_mobile || '9971236105';
  const secondary = settings.secondary_mobile || '';
  const storePhone = settings.store_phone || `+91 ${primary}`;
  return (
    <div className="max-w-3xl mx-auto px-4 py-12 sm:py-16">
      <h1 className="font-heading text-3xl sm:text-4xl text-stone-900">Contact us</h1>
      <p className="text-stone-600 mt-2">Need help with an order or have a question? Reach out anytime.</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        <a data-testid="contact-primary-phone" href={`tel:+91${primary}`} className="flex items-center gap-3 p-5 rounded-3xl bg-white border border-stone-200 hover:border-fresh-300 transition-colors">
          <Phone size={28} weight="duotone" className="text-fresh-700"/>
          <div><p className="text-xs text-stone-500">Call us (Primary)</p><p className="font-semibold text-stone-900">{storePhone}</p></div>
        </a>
        <a target="_blank" rel="noreferrer" data-testid="contact-whatsapp" href={`https://wa.me/${wa}`} className="flex items-center gap-3 p-5 rounded-3xl bg-white border border-stone-200 hover:border-fresh-300 transition-colors">
          <WhatsappLogo size={28} weight="duotone" className="text-[#25D366]"/>
          <div><p className="text-xs text-stone-500">WhatsApp</p><p className="font-semibold text-stone-900">+{wa}</p></div>
        </a>
        {secondary && (
          <a data-testid="contact-secondary-phone" href={`tel:+91${secondary}`} className="flex items-center gap-3 p-5 rounded-3xl bg-white border border-stone-200 hover:border-fresh-300 transition-colors">
            <Phone size={28} weight="duotone" className="text-fresh-700"/>
            <div><p className="text-xs text-stone-500">Call us (Secondary)</p><p className="font-semibold text-stone-900">+91 {secondary}</p></div>
          </a>
        )}
      </div>
    </div>
  );
}
